const readAssistantStream = async (reader, onEvent) => {
  const decoder = new TextDecoder();
  let buffered = "";
  const emit = (line) => {
    if (line.trim()) {
      onEvent(JSON.parse(line));
    }
  };
  try {
    while (true) {
      const { done, value } = await reader.read();
      if (done) {
        emit(buffered + decoder.decode());
        return;
      }
      const lines = (buffered + decoder.decode(value, { stream: true })).split("\n");
      buffered = lines.pop();
      lines.forEach(emit);
    }
  } catch (error) {
    reader.cancel().catch(() => {
    });
    throw error;
  }
};
export default readAssistantStream;
